<template>
  <div class="container">
    <div class="login-container">
      <el-row>
        <el-col :span="12">
          <div>
            <div class="Login_imgwrapper">
              <el-image class="Login_img" :src="login_img" fit="fill"></el-image>
            </div>
          </div>
        </el-col>
        <el-col :span="12">
          <div style="padding:20px;background:white;border-radius: 20px;">
            <div style="text-align:left;font-size:20px;padding:20px;font-weight: bold;">
              登录学习系统
            </div>

            <el-tabs v-model="activeName" type="border-card" @tab-click="handleClick">
              <el-tab-pane label="学生入口" name="student">
                <div>
                  <el-form ref="form" :model="form" label-width="80px" label-position="top" size="medium">
                    <el-form-item label="账号">
                      <el-input v-model="form.stuUsername" @input="accountTrimSpacing" placeholder="请输入学生账号"></el-input>
                    </el-form-item>
                    <el-form-item label="密码">
                      <el-input placeholder="请输入密码" v-model.trim="form.stuPassword" show-password @input="passwordTrimSpacing" @keyup.enter.native="onSubmit"></el-input>
                    </el-form-item>
                  </el-form>
                  <div style="text-align: center">
                    <el-button class="login_btn" style="padding-left: 50px; padding-right: 50px;margin-top:30px;" round type="primary" @click="onSubmit">登 录</el-button>
                  </div>
                </div>
              </el-tab-pane>
              <el-tab-pane label="老师入口" name="manager">
                <div>
                  <el-form ref="form" :model="form" label-width="80px" label-position="top" size="medium">
                    <el-form-item label="账号">
                      <el-input v-model="form.username" @input="accountTrimSpacing" placeholder="请输入老师账号"></el-input>
                    </el-form-item>
                    <el-form-item label="密码">
                      <el-input placeholder="请输入密码" v-model.trim="form.password" show-password @keyup.enter.native="onSubmit" @input="passwordTrimSpacing"></el-input>
                    </el-form-item>
                  </el-form>
                  <div style="text-align: center">
                    <el-button style="padding-left: 50px; padding-right: 50px;margin-top:30px;" round type="primary" @click="onSubmit">登 录
                    </el-button>
                  </div>
                </div>
              </el-tab-pane>
            </el-tabs>
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="footer" v-if="copy_right">
      <span>Copyright © STEAM.FUN 2023. All Rights Reserved</span>

      <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=12010302002038" target="_blank" style="
                            display: inline-block;
                            font-size: 10px;
                            font-weight: normal;
                            color:black;
                            margin-left: 20px;
                          ">
        <img style="width: 10px; height: 10px" src="https://wuge-homepage-resourse.oss-cn-beijing.aliyuncs.com/img/beian.png" />
        津公网安备 12010302002038号</a>

      <a href="https://beian.miit.gov.cn/" target="_blank" style="
                            display: inline-block;
                            font-size: 10px;
                            font-weight: normal;
                            color:black;
                            margin-left: 20px;
                          ">
        津ICP备17004637号-4</a>
    </div>
  </div>
</template>

<script>
import { getHomepage } from '@/api/homeset'
import { trimAll } from '@/utils/utils'

export default {
  name: 'login',
  data() {
    return {
      copy_right: true,
      activeName: 'student',
      login_img:
        'https://wugecdn.steam.fun/resources/static/school-management/steam_s.png',
      schoolname: '',
      isschool: false,
      domain: true,
      form: {
        username: '',
        password: '',
        stuUsername: '',
        stuPassword: '',
      },
    }
  },
  created() {
    if (sessionStorage.getItem('homepage') === null) {
      this.copy_right = true
    } else {
      this.copy_right = sessionStorage.getItem('homepage')
    }
    this.form = {
      username: '',
      password: '',
      stuUsername: '',
      stuPassword: '',
    }
  },
  mounted() {
    getHomepage().then((res) => {
      console.log('登录备案号')
      console.log(res)
      if (res.schoolInfo) {
        this.copy_right = res.homepageData.homepage.is_show_copy_right
      }
    })
  },

  methods: {
    handleClick() {
      console.log('切换登录入口')
      console.log(this.activeName)
      if (this.activeName == 'student') {
        this.login_img =
          'https://wugecdn.steam.fun/resources/static/school-management/steam_s.png'
      } else {
        this.login_img =
          'https://wugecdn.steam.fun/resources/static/school-management/steam_t.png'
      }
    },
    accountTrimSpacing() {
      this.form.username = trimAll(this.form.username)
      this.form.stuUsername = trimAll(this.form.stuUsername)
    },
    passwordTrimSpacing() {
      this.form.password = trimAll(this.form.password)
      this.form.stuPassword = trimAll(this.form.stuPassword)
    },
    onSubmit() {
      sessionStorage.removeItem('welcomeSpeechDisplayedText'); // 清除学生端AI文案
      this.accountTrimSpacing()
      this.passwordTrimSpacing()
      if (this.activeName == 'manager') {
        console.log('管理账号登录')
        const { username, password } = this.form
        if (!(username && password)) {
          return this.$message.error('请老师输入正确的账号和密码')
        }
        this.$store
          .dispatch('LoginByUsername', { username, password })
          .then((res) => {
            if (res === 'AuthFailure') return false;
            window.localStorage.removeItem('lastIgnoredDate')
            window.localStorage.removeItem('validPassword')
            if (window.outerWidth > 750) {
              this.$router.push({ path: '/' })
            } else {
              this.$router.push({ name: 'classroomIndex' })
            }
            this.$notify({
              title: '登录成功',
              message:
                '欢迎 ' + this.$store.state.user.userInfo.realName + ' 回来!',
              type: 'success',
              duration: 3000,
              offset: 45,
            })
          })
      } else {
        const { stuUsername, stuPassword } = this.form
        if (!(stuUsername && stuPassword)) {
          return this.$message.error('请学生输入正确的账号和密码')
        }
        this.$store
          .dispatch('LoginStuByUsername', {
            username: stuUsername,
            password: stuPassword,
          })
          .then((res) => {
            if (res === 'AuthFailure') return false;
            window.localStorage.removeItem('lastIgnoredDate')
            window.localStorage.removeItem('validPassword')
            if (window.outerWidth > 750) {
              this.$router.push({ path: '/' })
            } else {
              this.$router.push({ name: 'classroomIndexStu' })
            }

            this.$notify({
              title: '登录成功',
              message:
                '欢迎 ' +
                this.$store.state.user.userInfo.stuUserInfo.realName +
                ' 回来!',
              type: 'success',
              duration: 3000,
              offset: 45,
            })

            this.$store.dispatch('getStuTitleUrl')
          })

        console.log('学生登录')
      }
    },
    close() {
      this.$router.push({
        path: '/',
      })
    },
  },
}
</script>

<style scoped lang="scss">
.container {
  height: 100vh;
  min-width: 1000px;
  background: url(https://wugecdn.steam.fun/resources/static/school-management/steam_bg.png)
    no-repeat 50% / cover;
  background-size: 100% 100%;
}

.container .login-container {
  width: 800px;

  background-color: #233ea242;
  border-radius: 20px;
  position: absolute;
  top: 42%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.container .login-container .title {
  text-align: center;
  font-weight: bold;
  font-size: 20px;
}

.container .el-tabs--border-card {
  background: none !important;
  border: none !important;
  box-shadow: none !important;
}

/deep/ .el-tabs--border-card > .el-tabs__header {
  background: none !important;
}

.Login_img {
  border-radius: 20px 0px 0px 20px;
}

/deep/ .el-tabs--border-card > .el-tabs__header .el-tabs__item.is-active {
  background: none !important;
  border-bottom: 1px solid #717375;
  border-right: none !important;
  border-left: none !important;
}

/deep/ .el-tabs--border-card > .el-tabs__header .el-tabs__item {
  background: none !important;
  border: none !important;
}

/deep/ .el-form-item {
  margin-bottom: 0px !important;
}

/deep/ .el-form--label-top .el-form-item__label {
  padding: 0px !important;
}

/deep/ .el-tabs--border-card > .el-tabs__content {
  padding: 10px 20px 10px 20px !important;
}

.Login_imgwrapper {
  margin-top: 20px;
  width: 100%;
  height: 0;
  padding-bottom: 91.5%;

  -webkit-animation: bounce-down 1.6s linear infinite;
  animation: bounce-down 1.6s linear infinite;

  .Login_img {
    width: 100%;
  }
}

.footer {
  position: fixed;
  bottom: 20px;
  width: 100%;
  text-align: center;
  color: black;
}

@-webkit-keyframes bounce-down {
  25% {
    -webkit-transform: translateY(-4px);
  }

  50%,
  100% {
    -webkit-transform: translateY(0);
  }

  75% {
    -webkit-transform: translateY(4px);
  }
}

@keyframes bounce-down {
  25% {
    transform: translateY(-4px);
  }

  50%,
  100% {
    transform: translateY(0);
  }

  75% {
    transform: translateY(4px);
  }
}
</style>
